(function () {
  function setBodyLock(locked) {
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status === 'unprocessable_entity') return;

        var openDrawer = function () {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.open();
        };

        if (typeof publish !== 'undefined') {
          publish('cart-update', {
            source: 'tiger-gram',
            cartData: data
          }).then(openDrawer);
        } else {
          openDrawer();
        }
      })
      .catch(function () {});
  }

  function initTigerGram(section) {
    if (section.dataset.tigerGramInitialized === 'true') return;
    section.dataset.tigerGramInitialized = 'true';

    var tiles = section.querySelectorAll('[data-tiger-gram-open]');
    var popups = section.querySelectorAll('[data-tiger-gram-popup]');
    var gridWrap = section.querySelector('.tiger-gram__grid-wrap');
    var grid = section.querySelector('.tiger-gram__grid');
    var progress = section.querySelector('.tiger-gram__progress');
    var progressThumb = section.querySelector('.tiger-gram__progress-fill');
    var scrollPrev = section.querySelector('.tiger-gram__nav-btn--prev');
    var scrollNext = section.querySelector('.tiger-gram__nav-btn--next');
    if (!tiles.length || !popups.length) return;

    var activePopup = null;

    function getPopupIndex(popup) {
      return Array.prototype.indexOf.call(popups, popup);
    }

    function updateNavButtons(popup) {
      var index = getPopupIndex(popup);
      var prevBtn = popup.querySelector('.tiger-video-reviews__popup-nav-btn--prev');
      var nextBtn = popup.querySelector('.tiger-video-reviews__popup-nav-btn--next');

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= popups.length - 1;
    }

    function closePopup(popup) {
      if (!popup) return;
      popup.classList.remove('tiger-video-reviews__popup--open');
      popup.setAttribute('aria-hidden', 'true');
      popup.style.display = 'none';

      if (activePopup === popup) {
        activePopup = null;
        setBodyLock(false);
      }
    }

    function openPopup(popup) {
      if (!popup) return;

      popups.forEach(function (item) {
        if (item !== popup) closePopup(item);
      });

      popup.style.display = 'flex';
      popup.classList.add('tiger-video-reviews__popup--open');
      popup.setAttribute('aria-hidden', 'false');
      activePopup = popup;
      setBodyLock(true);
      updateNavButtons(popup);
    }

    function openById(id) {
      var popup = section.querySelector('[data-tiger-gram-popup][data-popup-id="' + id + '"]');
      openPopup(popup);
    }

    function getMaxScroll() {
      if (!gridWrap) return 0;
      return Math.max(gridWrap.scrollWidth - gridWrap.clientWidth, 0);
    }

    function updateScrollControls() {
      if (!gridWrap || !progressThumb || !progress) return;

      var maxScroll = getMaxScroll();
      var progressValue = maxScroll > 0 ? gridWrap.scrollLeft / maxScroll : 0;
      var fillWidth = maxScroll > 0 ? Math.max(Math.round(progressValue * 100), 8) : 8;

      progressThumb.style.left = '0%';
      progressThumb.style.width = fillWidth + '%';
      progress.setAttribute('aria-valuenow', Math.round(progressValue * 100));

      if (scrollPrev) scrollPrev.disabled = maxScroll <= 0 || gridWrap.scrollLeft <= 1;
      if (scrollNext) scrollNext.disabled = maxScroll <= 0 || gridWrap.scrollLeft >= maxScroll - 1;
      progressThumb.disabled = maxScroll <= 0;
    }

    function getScrollStep(direction) {
      if (!grid) return gridWrap ? gridWrap.clientWidth * direction : 0;

      var blocks = Array.prototype.slice.call(grid.querySelectorAll('.tiger-gram__block'));
      if (!blocks.length) return gridWrap.clientWidth * direction;

      var currentLeft = gridWrap.scrollLeft;
      var targetBlock = blocks[0];

      if (direction > 0) {
        for (var i = 0; i < blocks.length; i += 1) {
          if (blocks[i].offsetLeft > currentLeft + 2) {
            targetBlock = blocks[i];
            break;
          }
        }
        if (targetBlock.offsetLeft <= currentLeft + 2) targetBlock = blocks[blocks.length - 1];
      } else {
        for (var j = blocks.length - 1; j >= 0; j -= 1) {
          if (blocks[j].offsetLeft < currentLeft - 2) {
            targetBlock = blocks[j];
            break;
          }
        }
      }

      return targetBlock.offsetLeft - currentLeft;
    }

    function scrollByDirection(direction) {
      if (!gridWrap) return;
      gridWrap.scrollBy({
        left: getScrollStep(direction),
        behavior: 'smooth'
      });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        openById(tile.getAttribute('data-popup-id'));
      });
    });

    popups.forEach(function (popup) {
      var closeBtn = popup.querySelector('[data-tiger-gram-close]');
      var prevBtn = popup.querySelector('.tiger-video-reviews__popup-nav-btn--prev');
      var nextBtn = popup.querySelector('.tiger-video-reviews__popup-nav-btn--next');

      if (closeBtn) {
        closeBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closePopup(popup);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var index = getPopupIndex(popup);
          if (index > 0) openPopup(popups[index - 1]);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var index = getPopupIndex(popup);
          if (index < popups.length - 1) openPopup(popups[index + 1]);
        });
      }

      popup.querySelectorAll('.tiger-video-reviews__popup-cart-btn').forEach(function (button) {
        if (button.classList.contains('tiger-video-reviews__popup-cart-btn--link')) return;

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var variantId = button.getAttribute('data-variant-id');
          if (variantId) addToCart(variantId);
        });
      });

      popup.addEventListener('click', function (event) {
        if (event.target === popup) closePopup(popup);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activePopup) {
        closePopup(activePopup);
      }
    });

    if (gridWrap) {
      gridWrap.addEventListener('scroll', updateScrollControls, { passive: true });
      window.addEventListener('resize', updateScrollControls);
    }

    if (scrollPrev) {
      scrollPrev.addEventListener('click', function () {
        scrollByDirection(-1);
      });
    }

    if (scrollNext) {
      scrollNext.addEventListener('click', function () {
        scrollByDirection(1);
      });
    }

    if (progress && progressThumb && gridWrap) {
      function scrollToClientX(clientX) {
        var maxScroll = getMaxScroll();
        if (maxScroll <= 0) return;

        var rect = progress.getBoundingClientRect();
        var ratio = (clientX - rect.left) / rect.width;
        ratio = Math.max(0, Math.min(1, ratio));
        gridWrap.scrollTo({ left: maxScroll * ratio, behavior: 'smooth' });
      }

      progress.addEventListener('click', function (event) {
        scrollToClientX(event.clientX);
      });
    }

    updateScrollControls();
    setTimeout(updateScrollControls, 300);
    setTimeout(updateScrollControls, 800);
  }

  document.querySelectorAll('.tiger-gram').forEach(initTigerGram);
})();
